import { isNil } from '#packages/data-collection/libs/lodash';
import { type LoggingContext } from '#packages/data-collection/types/logging-context';
import { type KeyValueRepo } from '#packages/data-collection/repositories/kv-repo';
import { type Logger } from '#packages/data-collection/services/logger';

import { type LocalForageDb } from '#apps/client-web/app/services/local-forage-db';

export class LocalForageKeyValueRepo<TValue extends Object = any>
  implements KeyValueRepo<string, TValue>
{
  protected readonly db: LocalForageDb;
  protected readonly logger?: Logger;

  constructor({ db, logger }: { db: LocalForageDb } & LoggingContext) {
    this.db = db;
    this.logger = logger;
  }

  async get(key: string): Promise<TValue | null> {
    this.logger?.debug({ key }, 'Getting value from LocalForage KV Repo');

    const doc = await this.db.getItem<TValue>(key);
    this.logger?.debug(
      { key, doc, found: !isNil(doc) },
      'Value retrieved from LocalForage KV Repo',
    );

    return doc;
  }

  async set(key: string, value: TValue): Promise<void> {
    this.logger?.debug({ key, value }, 'Setting value in LocalForage KV Repo');
    await this.db.setItem(key, value);
  }

  async delete(key: string): Promise<void> {
    this.logger?.debug({ key }, 'Deleting value from LocalForage KV Repo');
    await this.db.removeItem(key);
  }
}
